module.exports = __webpack_public_path__ + "static/media/WateryM.9c87c2fc.jpg";